<template>
  <NuxtLayout name="dashboard">
    <div class="flex flex-col items-center gap-8">
      <img
        v-if="errorKeys[props.error?.status]"
        :src="errorKeys[props.error?.status]?.icon"
        alt="รูปที่เกี่ยวข้อง"
      />
      <div class="flex flex-col items-center gap-3">
        <span class="text-2xl text-slate-950 font-bold leading-8">
          {{ errorKeys[props.error?.status]?.title || props.error?.statusText }}
        </span>
        <template v-if="errorKeys[props.error?.status]">
          <component :is="errorKeys[props.error?.status]?.detail"></component>
        </template>
      </div>

      <div class="flex gap-2">
        <UButton :to="{ name: returnPathName }"> {{ returnLabel }} </UButton>
        <UButton
          :to="{ name: 'auth-login' }"
          variant="outline"
        >
          กลับสู่หน้า Login
        </UButton>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";
import Icon403 from "@/assets/images/403.svg";
import Icon404 from "@/assets/images/404.svg";

const route = useRoute();

const props = defineProps<{ error: NuxtError }>();

const errorKeys = {
  403: {
    icon: Icon403,
    title: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
    detail: h("div", { class: "flex flex-col items-center" }, [
      h(
        "span",
        { class: "text-slate-500" },
        "ขออภัย บัญชีของคุณยังไม่มีสิทธิ์เข้าถึงหน้านี้ ",
      ),
      h(
        "span",
        { class: "text-slate-500" },
        "กรุณาตรวจสอบสิทธิ์หรือติดต่อผู้ดูแลระบบ",
      ),
    ]),
  },
  404: {
    icon: Icon404,
    title: "ไม่พบหน้าที่ค้นหา",
    detail: h("div", { class: "flex flex-col items-center" }, [
      h("span", { class: "text-slate-500" }, "ระบบไม่พบข้อมูลตาม URL นี้"),
      h(
        "span",
        { class: "text-slate-500" },
        "หน้าดังกล่าวอาจถูกลบหรือมีการเปลี่ยนแปลง กรุณาตรวจสอบ URL อีกครั้ง",
      ),
    ]),
  },
};

const returnPathName = ref("slug");
const returnLabel = ref("กลับสู่หน้าแดชบอร์ด");

const authStore = useAuthStore();
const { isNormalUser } = storeToRefs(authStore);

onMounted(() => {
  if (/^\/admin/.test(route.path)) {
    returnPathName.value = "admin-slug";
    returnLabel.value = "กลับสู่หน้ารายงาน KOSA";

    if (!isNormalUser.value) return;
  }

  returnPathName.value = "slug";
  returnLabel.value = "กลับสู่หน้าแดชบอร์ด";
});
</script>
